export default defineNuxtPlugin((nuxtApp) => {
  // @ts-ignore
  globalThis.isNuxt = true
})
